import React, { FC } from 'react';
import { Formik, FormikProps, Form } from 'formik';
import { Grid, TextField, Button, makeStyles } from '@material-ui/core';
import * as Yup from 'yup';
import type { InsuranceInput } from './types';
import { Partner } from '../HotelForm/types';

const insuranceSchema = Yup.object().shape({
  company: Yup.string().required('Required')
});

interface Props {
  initialValues?: InsuranceInput;
  onSubmit: (values: InsuranceInput) => void;
  onSuccess?: () => void;
  submitLabel?: string;
  partnerOptions: Array<{ label: string; value: Partner }>;
}

const useStyles = makeStyles((theme) => ({
  input: {
    width: '100%'
  },
  button: {
    marginTop: theme.spacing(2)
  }
}));

const defaultValues = {
  company: ''
};

const InsuranceForm: FC<Props> = ({ onSubmit, onSuccess, initialValues = defaultValues, submitLabel = 'Add insurance' }) => {
  const { input, button } = useStyles();

  const handleSubmit = (values: InsuranceInput) => {
    const { id, ...rest } = values;
    onSubmit(rest);
    onSuccess?.();
  };

  return (
    <Formik enableReinitialize={true} initialValues={initialValues} onSubmit={handleSubmit} validationSchema={insuranceSchema}>
      {({ errors, touched, handleChange, handleBlur, values, setFieldValue }: FormikProps<InsuranceInput>) => (
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                id="outlined-name"
                label="Insurance company"
                name="company"
                value={values.company}
                variant="outlined"
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!errors.company && !!touched.company}
                helperText={!!errors.company && !!touched.company && errors.company}
                margin="normal"
                className={input}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id="outlined-name"
                label="Net total"
                name="total"
                value={values.total}
                onChange={handleChange}
                variant="outlined"
                onBlur={handleBlur}
                error={!!errors.total && !!touched.total}
                helperText={!!errors.total && !!touched.total && errors.total}
                margin="normal"
                className={input}
                onWheel={(e) => {
                  // Prevent the input value change
                  (e.target as HTMLInputElement).blur();;
                }}
                type="number"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="outlined-multiline-static"
                variant="outlined"
                label="Notes"
                name="notes"
                value={values.notes}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!errors.notes && !!touched.notes}
                helperText={!!errors.notes && !!touched.notes && errors.notes}
                style={{ width: '100%' }}
                multiline
              />
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" className={button} type="submit" color="primary">
                {submitLabel}
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default InsuranceForm;
